import type { HipotesisNormativa } from "../lib/api.ts";
import { C, st, dinero } from "../ui/theme.ts";
import { Chip, Fila } from "../ui/componentes.tsx";

function etiquetaFraccion(fraccion: string): string {
  const etiquetas: Record<string, string> = {
    ART17_V_desarrollo: "Fr. V · Inmuebles",
    ART17_V_intermediacion: "Fr. V · Intermediación",
    ART17_V_BIS: "Fr. V Bis · Desarrollo",
    ART17_XV: "Fr. XV · Uso o goce",
    ART32_I_efectivo: "Art. 32 · Efectivo",
  };
  return etiquetas[fraccion] ?? fraccion;
}

function chips(h: HipotesisNormativa) {
  return (
    <>
      {h.requiere_aviso && <Chip tono="ambar">Aviso</Chip>}
      {h.excede_acumulado_bc && <Chip tono="azul">Revisión BC</Chip>}
      {h.adaptador_pendiente && <Chip tono="gris">Adaptador pendiente</Chip>}
      {h.fraccion === "ART32_I_efectivo" && <Chip tono={h.excede_individual ? "rojo" : "gris"}>Efectivo</Chip>}
      {!h.requiere_aviso && !h.excede_acumulado_bc && h.fraccion !== "ART32_I_efectivo" && <Chip tono="verde">Sin aviso</Chip>}
    </>
  );
}

export function HipotesisNormativasCard({ hipotesis }: { hipotesis: HipotesisNormativa[] | undefined }) {
  const xs = hipotesis ?? [];
  return (
    <div style={st.tarjeta}>
      <p style={st.eyebrow}>Hipótesis normativas del evento</p>
      {xs.length === 0 ? (
        <p style={{ margin: 0, color: C.muted, fontSize: 13 }}>Sin hipótesis generadas todavía.</p>
      ) : (
        <div style={{ display: "grid", gap: 10 }}>
          {xs.map((h) => (
            <div key={`${h.evento_id}-${h.fraccion}`} style={{ border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
                <span style={{ color: C.ink, fontSize: 13.5, fontWeight: 800 }}>{etiquetaFraccion(h.fraccion)}</span>
                <span style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "flex-end" }}>{chips(h)}</span>
              </div>
              {h.fundamento && <div style={{ color: C.muted, fontSize: 12.5, marginBottom: 6 }}>{h.fundamento}</div>}
              <Fila k="Base individual" v={dinero(h.base_individual)} />
              <Fila k="Acumulado directo" v={dinero(h.acumulado_directo)} />
              {h.acumulado_bc !== null && <Fila k="Acumulado por BC" v={dinero(h.acumulado_bc)} />}
              <Fila k="Umbral" v={dinero(h.umbral_pesos)} />
              <Fila k="Formato" v={h.formato_aviso ?? h.formato_oficial ?? "-"} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function HipotesisInline({ hipotesis }: { hipotesis: HipotesisNormativa[] | undefined }) {
  const xs = hipotesis ?? [];
  if (xs.length === 0) return null;
  return (
    <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginTop: 5 }}>
      {xs.map((h) => (
        <Chip key={`${h.evento_id}-${h.fraccion}`} tono={h.excede_acumulado_bc ? "azul" : h.requiere_aviso ? "ambar" : h.adaptador_pendiente ? "gris" : "verde"}>
          {etiquetaFraccion(h.fraccion)}
        </Chip>
      ))}
    </div>
  );
}
